// src/components/ui/ScrollCTA.js

import React from 'react';
import { Gift, X, Sparkles, Clock, TrendingUp } from 'lucide-react';

const ScrollCTA = ({ onClose, onOpenAuthModal }) => {
  return (
    <div className="fixed bottom-4 right-4 w-full max-w-sm z-40 animate-fade-in-up">
      <div className="bg-white rounded-xl shadow-2xl border border-slate-200 p-5">
        <div className="flex justify-between items-start mb-3">
          <div className="flex items-center">
            <div className="bg-green-100 p-2 rounded-full mr-3">
              <Gift size={22} className="text-green-600" />
            </div>
            <div>
              <h3 className="font-bold text-slate-800">Ready to Grow Your Store?</h3>
              <p className="text-sm text-slate-500">Start your free 1-hour trial now.</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <ul className="space-y-2 text-sm my-4">
          <li className="flex items-center">
            <Sparkles className="h-4 w-4 mr-2 flex-shrink-0 text-amber-500" />
            <span className="text-slate-600">Instant Content Creation</span>
          </li>
          <li className="flex items-center">
            <Clock className="h-4 w-4 mr-2 flex-shrink-0 text-blue-500" />
            <span className="text-slate-600">Save Hours Weekly</span>
          </li>
          <li className="flex items-center">
            <TrendingUp className="h-4 w-4 mr-2 flex-shrink-0 text-green-500" />
            <span className="text-slate-600">Boost Your Visibility & Rank</span>
          </li>
        </ul>

        <button
          onClick={onOpenAuthModal}
          className="w-full bg-sky-600 hover:bg-sky-700 text-white font-semibold py-2.5 px-4 rounded-lg shadow-md transition-colors"
        >
          Sign Up & Start Free Trial
        </button>
      </div>
    </div>
  );
};

export default ScrollCTA;